import React from 'react';
import PropTypes from 'prop-types';
import Navigation from './Navigation';
class QuestionPointDeVente extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: 'none',
    };
  }

  render() {
    const item = this.props.dataItems[0];
    return (
      <div
        className="input-container flex-input items-center justify-center"
        style={{ marginBottom: '40px', marginTop: '40px' }}
        key={item.name}
      >
        {item.label && (
          <label className="mt-10" style={{ width: '90px' }}>
            {item.label}
          </label>
        )}
        <select
          value={this.props.value}
          placeholder={item.placeholder}
          name={item.name}
          onChange={this.props.handleData}
        >
          <option key="placeholder" value="">
            {item.placeholder}
          </option>
          {item.options.map((item, index) => (
            <option key={index} value={item.name}>
              {item.label}
            </option>
          ))}
        </select>
        {this.props.pdvOnly && (
          <Navigation
            data={this.props.data}
            step={this.props.step}
            nextStep={this.props.nextStep}
            lastStep={this.props.lastStep}
          />
        )}
      </div>
    );
  }
}

QuestionPointDeVente.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleData: PropTypes.func.isRequired,
  dataItems: PropTypes.array.isRequired,
  pdvOnly: PropTypes.bool,
  data: PropTypes.bool,
  step: PropTypes.number,
  nextStep: PropTypes.func,
  lastStep: PropTypes.func,
};

export default QuestionPointDeVente;
